import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionsDirective } from './has-permission/has-permission.directive';

@NgModule({
  declarations: [HasPermissionsDirective],
  imports: [CommonModule],
  exports: [HasPermissionsDirective]
})
export class DirectiveModule {

}
